import PropTypes from 'prop-types';
import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { connect } from 'react-redux';
import AccountManagerLink from '../AccountManagerLink/AccountManagerLink';
import VipAccountManagerLink from '../VipAccountManagerLink/VipAccountManagerLink';
import SiteNav from '../SiteNav/SiteNav';

import styles from './BottomBar-style.scss';

const BottomBar = (props) => {
    const {isUserTypeTrade, isUserTypeVip} = props;
    const showVipAccountManagerLink = !isUserTypeTrade && isUserTypeVip;
    return (
        <div className={styles.bar}>
            <div className={styles.barContent}>
                <div className={styles.wrapper}>
                    <SiteNav navigation={props.navigation}/>
                    { props.isUserTypeTrade ? <AccountManagerLink/> : null }
                    { showVipAccountManagerLink ?
                        <VipAccountManagerLink
                            hasRootPendingRefetch={props.hasRootPendingRefetch}
                            hasUserId={props.hasUserId}
                            isClient={props.isClient}
                            userIds={props.userIds}
                            viewer={props.viewer}
                        /> : null }
                </div>
            </div>
        </div>
    );
};

BottomBar.propTypes = {
    navigation: PropTypes.object,
    hasRootPendingRefetch: PropTypes.bool,
    hasUserId: PropTypes.bool,
    isClient: PropTypes.bool,
    isUserTypeTrade: PropTypes.bool,
    isUserTypeVip: PropTypes.bool,
    userIds: PropTypes.array,
    viewer: PropTypes.object
};

const mapStateToProps = ({ header }) => {
    const { isUserTypeTrade, isUserTypeVip } = header;
    return {
        isUserTypeTrade, isUserTypeVip
    };
};


export default createFragmentContainer(
    connect(mapStateToProps)(BottomBar),
    {
        navigation: graphql`
            fragment BottomBar_navigation on Navigation {
                ...SiteNav_navigation
            }
        `,
        viewer: graphql`
            fragment BottomBar_viewer on Viewer {
                ...VipAccountManagerLink_viewer
            }
        `
    }
);



// WEBPACK FOOTER //
// ./src/components/BottomBar/BottomBar.jsx